import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, UnitaDiMisura, UnitaDiMisuraLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class UnitaDiMisuraService extends CrudGenericsService<UnitaDiMisura, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/UnitaDiMisura`);
    this.base = `${env.apiUrl}/api/UnitaDiMisura/`;
  }

  GetAllLng(): Observable<UnitaDiMisuraLng[]> {
    const url = this.base + 'GetAllLng';
    return this.http.get<UnitaDiMisuraLng[]>(`${url}`);
  }
}
